import { resolveValueColorFromStops } from './liquidShared';

export const ASSET_STATUS_WIDGET_TYPE = 'asset-status';
export const STATUS_ARROW_WIDGET_TYPE = 'status-arrow';

export const ASSET_STATUS_ANIMATIONS = [
  { label: 'None', value: 'none' },
  { label: 'Pulse', value: 'pulse' },
  { label: 'Blink', value: 'blink' },
  { label: 'Glow', value: 'glow' },
  { label: 'Shake', value: 'shake' },
  { label: 'Sweep', value: 'sweep' },
];

export const ARROW_SHAPE_OPTIONS = [
  { label: 'Straight', value: 'straight' },
  { label: 'Elbow', value: 'elbow' },
  { label: 'Elbow 2', value: 'elbow-2' },
  { label: 'Curve', value: 'curve' },
  { label: 'S Curve', value: 's-curve' },
  { label: 'Step', value: 'step' },
];

export const ARROW_ANCHOR_OPTIONS = [
  { label: 'Left', value: 'left' },
  { label: 'Right', value: 'right' },
  { label: 'Top', value: 'top' },
  { label: 'Bottom', value: 'bottom' },
];

export const STATUS_RULE_OPERATORS = [
  { label: 'Range', value: 'range' },
  { label: 'Equal', value: 'eq' },
  { label: 'Greater / equal', value: 'gte' },
  { label: 'Less / equal', value: 'lte' },
];

export const normalizeTextValue = (value) => String(value ?? '').trim().toLowerCase();

export const getDatastreamKey = (dataId, pin) => {
  if (dataId !== undefined && dataId !== null && String(dataId) !== '' && Number(dataId) > 0) {
    return `id:${dataId}`;
  }
  if (pin !== undefined && pin !== null && String(pin).trim() !== '') {
    return `pin:${String(pin).trim()}`;
  }
  return '';
};

export const findDatastreamMeta = (datastreams, dataId, pin) => {
  const list = Array.isArray(datastreams) ? datastreams : [];
  if (dataId !== undefined && dataId !== null && Number(dataId) > 0) {
    const byId = list.find((ds) => Number(ds?.id) === Number(dataId));
    if (byId) return byId;
  }
  if (pin !== undefined && pin !== null && String(pin).trim() !== '') {
    const byPin = list.find((ds) => String(ds?.pin || '') === String(pin));
    if (byPin) return byPin;
  }
  return null;
};

export const readDatastreamValue = (datastream) => {
  if (!datastream) return '';
  if (datastream.value !== undefined && datastream.value !== null && String(datastream.value).trim() !== '') {
    return datastream.value;
  }
  if (datastream.defaultValue !== undefined && datastream.defaultValue !== null) {
    return datastream.defaultValue;
  }
  return '';
};

export const formatAssetStatusValue = (value, decimals) => {
  const numericValue = Number(value);
  const numericDecimals = Number(decimals);
  if (Number.isFinite(numericValue) && Number.isFinite(numericDecimals)) {
    return Number(numericValue.toFixed(Math.max(0, numericDecimals))).toString();
  }
  if (value === undefined || value === null || String(value).trim() === '') return '--';
  return String(value);
};

export const getValueRuleMatch = (value, rules = []) => {
  const rawText = String(value ?? '').trim();
  const normalizedText = normalizeTextValue(rawText);
  const numericValue = Number(value);

  return (Array.isArray(rules) ? rules : []).find((rule) => {
    if (!rule) return false;
    const operator = rule.operator || 'range';

    if (operator === 'eq') {
      return normalizeTextValue(rule.equals) === normalizedText;
    }

    if (!Number.isFinite(numericValue)) return false;

    const from = Number(rule.from);
    const to = Number(rule.to);

    if (operator === 'gte') {
      return Number.isFinite(from) && numericValue >= from;
    }

    if (operator === 'lte') {
      return Number.isFinite(to) && numericValue <= to;
    }

    const min = Number.isFinite(from) ? from : -Infinity;
    const max = Number.isFinite(to) ? to : Infinity;
    return numericValue >= Math.min(min, max) && numericValue <= Math.max(min, max);
  }) || null;
};

export const resolveStatusVisualState = ({
  value,
  baseColor = '#00d26a',
  rules,
  colors,
  changeColorBasedOnValue,
  colorGrading,
  defaultAnimation = 'none',
}) => {
  const matchingRule = getValueRuleMatch(value, rules);

  const colorFromRules = matchingRule?.color;
  const colorFromStops = resolveValueColorFromStops({
    value,
    baseColor,
    stops: colors,
    enabled: changeColorBasedOnValue,
    grading: colorGrading,
  });

  return {
    color: colorFromRules || colorFromStops || baseColor,
    animation: matchingRule?.animation || defaultAnimation || 'none',
    label: matchingRule?.label || '',
  };
};
